<template>
  <div class="text-input">
    <label>
      <span class="block mb-5">
        <slot />
      </span>
      <span class="relative block">
        <input
          v-bind="$attrs"
          :value="value"
          class="input w-full h-45 px-15 border-2 border-gray-300 rounded-sm appearance-none"
          :class="{
            'pr-45': invalidIconIsVisible || validIconIsVisible,
            'is-invalid': invalidIconIsVisible,
          }"
          @input="$emit('input', $event.target.value)"
          @change="$emit('change', value)"
        >
      <Transition name="fade-in-linear">
        <!-- <IconFA
          v-if="invalidIconIsVisible"
          :icon="['far', 'times']"
          size="lg"
          class="icon fa-fw absolute right-0 text-failure"
        /> -->
        <IconFA
          v-if="validIconIsVisible"
          :icon="['far', 'check']"
          size="lg"
          class="icon fa-fw absolute right-0 text-success"
        />
      </Transition>
      </span>
    </label>
    <SmoothReflow
      tag="div"
      :options="{
        property: 'height',
        transition: 'height 300ms cubic-bezier(0.77, 0, 0.175, 1)',
      }"
    >
      <div v-if="validationMessageIsVisible">
        <p
          class="text-sm font-medium pt-5"
          :class="errorTextColor"
        >
          {{ validationMessage }}
        </p>
      </div>
    </SmoothReflow>
  </div>
</template>


<script>
import SmoothReflow from '@/components/SmoothReflow';


export default {
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    noIcons: {
      type: Boolean,
      default: false,
    },
    noSuccessIcon: {
      type: Boolean,
      default: false,
    },
    errorTextColor: {
      type: String,
      default: 'text-failure',
    },
    rules: {
      type: Array,
      default() {
        return [];
      },
      validator(value) {
        for (let i = 0; i < value.length; i += 1) {
          if (!value[i].errorTextKey
            || value[i].validationFunction === undefined
            || !value[i].trigger) {
            return false;
          }
        }
        return true;
      },
    },
  },
  components: {
    SmoothReflow,
  },
  data: () => ({
    validationMessageIsVisible: false,
    validationStatus: '',
    validationMessage: '',
    validationTimer: null,
  }),
  computed: {
    invalidIconIsVisible() {
      return this.validationStatus === 'failed' && !this.noIcons;
    },
    validIconIsVisible() {
      return this.validationStatus === 'success' && !this.noIcons && !this.noSuccessIcon;
    },
  },
  methods: {
    async validateInput() {
      this.validationMessage = '';

      for (let i = 0; i < this.rules.length; i += 1) {
        if (!this.rules[i].validationFunction(this.value)) {
          this.validationMessageIsVisible = true;
          this.validationMessage += this.$t(this.rules[i].errorTextKey);
          this.validationStatus = 'failed';

          return Promise.reject();
        }
      }

      this.validationMessageIsVisible = false;
      this.validationStatus = 'success';

      return Promise.resolve();
    },
    resetValidationStatus() {
      this.validationMessageIsVisible = false;
      this.validationMessage = '';
      this.validationStatus = '';
    },
  },
};
</script>


<style scoped>
.text-input .input {
  transition: border 0.3s;
}

.input::placeholder {
  @apply text-secondary-light;
}

.input:focus,
.input:hover {
  @apply border-secondary;
}

.is-invalid {
  @apply border-failure;
}

.text-input .icon {
  top: 50%;
  right: theme(spacing.10);
  transform: translate(0, -50%);
}
</style>
